<script setup lang="ts">
import { onMounted, ref } from 'vue'

defineProps<{
    title: string
    last: boolean
    id?: string
}>()

// inital maxHeight of the element
let maxHeight: string = ''

const active = ref<boolean>(true)

onMounted(() => {
    const descriptionElement = Array.from(document.getElementsByClassName('accordion-description') as HTMLCollectionOf<HTMLElement>)[0]
    maxHeight = descriptionElement.clientHeight + 'px'
    active.value = false
})
</script>

<template>
    <div
        :class="{ active: active }"
        class="accordion overflow-hidden"
    >
        <button
            :id="id ? id + '-btn' : undefined"
            class="accordion-title flex w-full cursor-pointer items-center justify-between border-t bg-white p-4 text-lg font-medium text-primary-500 outline-none transition-all duration-300 hover:bg-primary-500 hover:text-white focus:bg-primary-500 focus:text-white"
            :class="{ 'border-b': last && !active }"
            :aria-expanded="active"
            :aria-controls="id"
            @click="active = !active"
        >
            {{ title }}
            <i
                class="icon fa-solid fa-chevron-down transition-all duration-300 ease-in-out"
                :class="{ 'rotate-180': active }"
            />
        </button>
        <div
            :id="id"
            role="region"
            class="accordion-description"
            :style="{ maxHeight: active ? maxHeight : '0px' }"
            :class="{ 'border-b': last && active }"
            :aria-labelledby="id ? id + '-btn' : undefined"
        >
            <div class="inner px-4 pb-8 pt-1">
                <slot />
            </div>
        </div>
    </div>
</template>

<style scoped>
.accordion-description {
    overflow: hidden;
    transition: max-height 0.3s ease-in-out;
    box-sizing: border-box;
}
</style>
